import React from 'react';
import AdvantageItem from './AdvantageItem';
import LightningIcon from '../../assets/icons/LightningIcon';
import DeliveryIcon from '../../assets/icons/DeliveryIcon';
import CertifiedIcon from '../../assets/icons/CertifiedIcon';
import DiscountIcon from '../../assets/icons/DiscountIcon';

function Advantages() {
  const advantages = [
    {
      icon: <LightningIcon />,
      text: 'Большой выбор брендов и категорий',
    },
    {
      icon: <DeliveryIcon />,
      text: 'Быстрая доставка по всему Казахстану',
    },
    {
      icon: <CertifiedIcon />,
      text: 'Только сертифицированная продукция',
    },
    {
      icon: <DiscountIcon />,
      text: 'Выгодные акции и скидки',
    },
  ];

  return (
    <div className="container mx-auto md:px-4 flex flex-wrap justify-center gap-4 my-8">
      {advantages.map((advantage, index) => (
        <AdvantageItem key={index} icon={advantage.icon} text={advantage.text} />
      ))}
    </div>
  );
};

export default Advantages;
